export default __webpack_public_path__ + "static/media/big_head_-2.546517d0.webp";